module.exports = __webpack_public_path__ + "static/media/nb_akademie_black-webfont.3931a3b1.ttf";